/* unplugin-vue-components disabled */import { render } from "./Selector.vue?vue&type=template&id=b106f6ae&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"

import "./Selector.vue?vue&type=style&index=0&id=b106f6ae&scoped=true&lang=less"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b106f6ae"]])

export default __exports__